import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchLogin = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/login`, formData);
        return response;
    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }
};

export const fetchGetPerfil = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/auth/getPerfil`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchGetImgPerfil = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/auth/getImgPerfil`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchModificarPerfil = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/modificarPerfil`, formData, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
}

export const fetchSolicitarRecuperacion = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/solicitarRecuperacion`, formData, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        // Conservamos el comportamiento especial para este endpoint
        console.log("Ha habido un error:", error);
        if (error.response) {
            return error.response;
        }
        throw error;
    }
}

export const fetchValidarToken = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/validarTokenRecuperacion`, formData);
        return response;
    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }
};

export const fetchRestablecerContraseña = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/cambiarPassword`, formData);
        return response;
    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }
}

export const fetchSolicitarUrlBitWarden = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/email/url/bitwarden`, formData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }
}

// ==================== 2FA ====================

/* Fase 13 · aquí estaba `fetchVerify2FA`, la llamada al segundo paso del login.
 * Se ha ido con su endpoint. Las de `fetch2FAStatus`, `setup` y demás se quedan: configurar el
 * segundo factor sigue siendo lo que da acceso a las puertas. */

export const fetch2FAStatus = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/auth/2fa/status`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchSetup2FA = async () => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/2fa/setup`, {}, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchVerifySetup2FA = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/2fa/verify-setup`, formData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchDisable2FA = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/2fa/disable`, formData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchRegenerateBackupCodes = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/auth/2fa/regenerate-backup-codes`, formData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};